/**
 * @description client mutations
 */
import {setStorageCache} from '../../utils/'
import {types} from '../constants/types'

const {UPDATE_CLIENT_INFO, UPDATE_USER_INFO, UPDATE_ENV} = types

export default {
  [UPDATE_CLIENT_INFO](state, {data}) {
    state.client = {...state.client, ...data}
  },
  [UPDATE_USER_INFO](state, {data}) {
    state.user = {...state.user, ...data}
    setStorageCache('cacheUser', state.user)
  },
  [UPDATE_ENV](state, {data}) {
    state.client = {...state.client, ...data}
  }
}
